<template>
  <div>
    <form @submit.prevent="createUpdateDevice">
      <modal v-show="isModalVisible" @close="closeModal" footer>
        <template v-slot:title>
          <h5>
            {{ device.id ? "Update Device" : "Create New Device" }}
          </h5>
        </template>
        <template v-slot:body>
          <div class="form-group">
            <label for="status">Status</label>
            <br />
            <select
              id="select"
              class="form-select fw-two form-control"
              v-model="device.type"
            >
              <option value selected disabled>Type</option>
              <option
                value="android"
                class="mb-2"
                :selected="device.type == 'android'"
                >Android Terminal</option
              >
              <option
                value="traditional"
                class="mb-2"
                :selected="device.type == 'traditional'"
                >Traditional</option
              >
            </select>
          </div>
          <div class="form-group">
            <label for="title">Imei</label>
            <input
              type="text"
              class="form-control"
              name="title"
              v-model="device.imei"
            />
          </div>
          <div class="form-group">
            <label for="title">Serial No</label>
            <input
              type="text"
              class="form-control"
              name="title"
              v-model="device.serial_no"
            />
          </div>
          <div class="form-group">
            <label for="title">Manufacturer</label>
            <input
              type="text"
              class="form-control"
              name="title"
              v-model="device.manufacturer"
            />
          </div>
          <div class="form-group">
            <label for="title">Model</label>
            <input
              type="text"
              class="form-control"
              name="title"
              v-model="device.model"
            />
          </div>
        </template>
        <template v-slot:footer>
          <button
            v-if="
              permissions.includes('update-device') ||
                permissions.includes('add-device')
            "
            type="submit"
            class="button"
            :disabled="loading || !formIsValid"
          >
            <span class="custom-loader" v-if="loading">
              <loader-icon size="1.5x" class="custom-class"></loader-icon>
              <span style="font-weight: 600; text-transform: initial;"
                >Please wait...</span
              >
            </span>
            <span v-else>
              {{ device.id ? "Update Device" : "Create New Device" }}
            </span>
          </button>
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="closeModal"
          >
            Cancel
          </button>
        </template>
      </modal>
    </form>

    <div
      v-if="pageLoading"
      style="display: flex; top: 0px; position: fixed; left: 0px; right: 0px; bottom: 0px; background-color: rgba(247, 247, 247, 0.9); z-index: 9999; justify-content: center; align-items: center;"
    >
      <div>
        <div>
          <h3>Getting Devices ready...</h3>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row align-items-center justify-content-between mb-2">
        <div class="col">
          <h1 class="mb-2 font-regular">Devices</h1>
        </div>
        <div class="col-auto">
          <button
            v-if="permissions.includes('add-device')"
            class="button button--outline text-uppercase"
            @click="openModal"
          >
            Add Device
          </button>
        </div>
      </div>

      <div class="card card--no-shadow">
        <div class="card-header">
          <slot name="header">
            <h4 class="card-title">Devices</h4>
          </slot>
        </div>
        <div class="card-content">
          <div class="card-body">
            <CDataTable
              :items="devices"
              :fields="fields"
              sorter
              tableFilter
            >
              <template #created_at="{item}">
                <td class="table--action-mobile">
                  {{ item.created_at | date }}
                </td>
              </template>
              <template #action="{item}">
                <td class="table--action-mobile">
                  <button
                    v-if="
                      permissions.includes('view-device') ||
                        permissions.includes('update-device')
                    "
                    class="button btn-success"
                    style="background-color: #0bc681;"
                    @click="showUpdateModal(item)"
                  >
                    {{
                      permissions.includes("update-device")
                        ? "View/Update"
                        : "View"
                    }}
                  </button>
                </td>
              </template>
            </CDataTable>
            <CPagination
              :activePage.sync="next_page"
              :pages="total"
              :onActivePageChange="onPageChange()"
            ></CPagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "../../services/api.service";
import ErrorService from "../../services/error.service";
import Swal from "sweetalert2";
import CDataTable from "../../components/CDataTable.vue";
import CPagination from "@/components/CPagination.vue";
const fields = [
  "deviceID",
  "serial_no",
  "manufacturer",
  "type",
  "created_at",
  "action"
];
export default {
  name: "ChargesSettings",
  components: {
    CDataTable,
    CPagination
  },
  data() {
    return {
      fields,
      devices: [],
      next_page: 1,
      current: 1,
      total: 1,
      small: true,
      device: {},
      loading: false,
      pageLoading: false,
      isModalVisible: false
    };
  },
  computed: {
    formIsValid() {
      return (
        this.device.imei !== "" &&
        this.device.serial_no !== "" &&
        this.device.manufacturer !== "" &&
        this.device.model !== ""
      );
    },
    permissions() {
      let permissions = this.$store.getters.permissions;
      return permissions;
    }
  },
  methods: {
    showUpdateModal(item) {
      this.device = Object.assign({}, item);
      this.isModalVisible = true;
    },
    openModal() {
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
      this.device = {};
    },

    async getDevices(page) {
      try {
        this.pageLoading = true;
        const response = await ApiService.get(`terminal/devices?page=${page}`);

        this.devices = response.data.data.data;
        this.current = response.data.data.current_page;
        this.total = response.data.data.last_page;
        this.pageLoading = false;
      } catch (error) {
        console.log(error);
        console.log(error.response);
        this.pageLoading = false;
      }
    },
    onPageChange() {
      if (this.current != this.next_page) {
        this.getDevices(this.next_page);
      }
    },

    async createUpdateDevice() {
      try {
        this.loading = true;
        const response = await ApiService.post(
          "terminal/add-device",
          this.device
        );
        this.loading = false;
        this.closeModal();
        Swal.fire({
          title: "Success",
          text: response.data.message,
          icon: "success",
          confirmButtonText: "Ok"
        });
        this.getDevices(this.current);
        this.loading = false;
        this.closeModal();
      } catch (error) {
        console.log(error.response);
        this.loading = false;
        let _error = error.response.data;
        this.closeModal();
        ErrorService.displayErrorAlert(_error);
      }
    }
  },
  mounted() {
    this.getDevices(1);
  }
};
</script>
